import React, {useEffect, useState} from "react";
import {Container, Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import Service from "../services/Service";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from '@material-ui/lab/Alert';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import DialogActions from "@material-ui/core/DialogActions";
import _ from 'lodash'
import {useDispatch, useSelector} from "react-redux";
import {getPortfolios} from "../store/actions";
import {currencies} from "../AppConstants";


const service = new Service();
const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export default function PortfolioCards() {
    const dispatch = useDispatch()
    const [portfolios, setPortfolios] = useState([]);
    const portfolioList = useSelector(store => store.portfolios?.list || {});
    const [open, setOpen] = useState(false);
    const [openAlert, setOpenAlert] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSend = () => {

        //setOpen(false);
        if (activePostfolio) {
            service.updatePortfolio(
                {
                    "pk": activePostfolio,
                    "name": name,
                    "currency": currency
                },
                activePostfolio
            ).then(function (response) {
                console.log(response)
                dispatch(getPortfolios())
                setOpen(false);
                setCurrency('RUB');
                setName('');
                setActivePostfolio();
            }).catch(() => {
                alert('Ошибка при редактировании');
            });
        } else {
            service.createPortfolio(
                {
                    "name": name,
                    "currency": currency
                }
            ).then((result) => {
                console.log(result)
                dispatch(getPortfolios())
                setOpen(false);
                setCurrency('RUB');
                setName('');
                setActivePostfolio();
                setOpenAlert(true);
            }).catch(() => {
                alert('Ошибка при добавлении');
            });
        }


    };
    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };
    const [currency, setCurrency] = useState('RUB');
    const [name, setName] = useState('');
    const [activePostfolio, setActivePostfolio] = useState();

    const handleChange = (event) => {
        setCurrency(event.target.value);
    };
    const useStyles = makeStyles({
        gridContainer: {
            paddingTop: "40px"
        },
        root: {
            minWidth: 200,
            minHeight: 150
        },
        title: {
            fontSize: 14
        },
        pos: {
            marginBottom: 12
        }
    });
    // useEffect(() => {
    //
    //     service.getPortfolios().then(function (response) {
    //             setPortfolios(response)
    //         }
    //     )
    // }, []);
    const classes = useStyles();
    const handleDelete = (pk) => {
        service.deletePortfolio(pk).then((result) => {
            console.log(result)
            dispatch(getPortfolios())
        });
    };
    const handleEditForm = (pk) => {
        var activeEdit = _.find(portfolioList, {'id': pk}); //portfolios.find(obj => obj.id === pk)
        setName(activeEdit.name);
        setCurrency(activeEdit.currency);
        setActivePostfolio(pk)
        console.log(activePostfolio)
        setOpen(true);
        //setPortfolios(newArr)
    };
    return (
        <Container style={{marginTop: 30}}>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
            <Typography variant="h5" component="h2">
                Управление портфелями
            </Typography>
            <Button variant="outlined" color="primary" onClick={handleClickOpen}>
                Добавить
            </Button>
            </Grid>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Добавить портфель</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        required
                        autoComplete='off'
                        margin="dense"
                        id="name"
                        label="Название"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        placeholder="Новый портфель"
                        fullWidth
                    />
                    <TextField
                        id="currency"
                        select
                        label="Валюта портфеля"
                        value={currency}
                        onChange={handleChange}
                        fullWidth
                    >
                        {currencies.map((option) => (
                            <MenuItem key={option.id} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Отменя
                    </Button>
                    <Button onClick={handleSend} color="primary">
                        Ок
                    </Button>
                </DialogActions>
            </Dialog>
            <Grid
                container
                spacing={4}
                className={classes.gridContainer}
                //justifyContent="space-between"
            >
                {/*JSON.stringify(portfolioList)*/}                
                {_.map(portfolioList, (item, index, collection) =>
                    <Grid item key={item.id} xs={12} sm={6} md={4}>
                        <Card className={classes.root} variant="outlined">
                            <CardContent>
                                <Typography variant="h5" component="h2">
                                    {item.name}
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {item.currency}
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" onClick={() => handleEditForm(item.id)}>Редактировать</Button>
                                <Button size="small" color="secondary"
                                        onClick={() => handleDelete(item.id)}>Удалить</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                )}
            </Grid>
            <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity="success">
                    Портфель добавлен!
                </Alert>
            </Snackbar>
        </Container>
    );
}
